import { useMemo } from 'react';

import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { nestedFieldValueGetter } from 'utils/grid';

import { GridColDef } from '@mui/x-data-grid-pro';

import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';

const useColumnDefinitions = () => {
  const { t } = useTranslation();

  return useMemo(() => {
    return generateColumns(t);
  }, [t]);
};

const generateColumns = (t: TFunction): GridColDef[] => [
  {
    field: 'grantName',
    headerName: t('grants.modules.grid.grantName'),
    type: 'string',
    flex: 2
  },
  {
    field: 'description',
    headerName: t('grants.modules.grid.description'),
    type: 'string',
    flex: 2,
    valueGetter: ({ row }) =>
      row.grantName
        ? t([`grants.modules.module_description.${row.grantName}`])
        : ''
  },
  {
    field: 'enabled',
    headerName: t('grants.modules.grid.enabled'),
    type: 'boolean',
    flex: 1,
    renderCell: BooleanCell,
    valueGetter: nestedFieldValueGetter
  }
];

export default useColumnDefinitions;
